require('iframe-resizer');
iFrameResize({heightCalculationMethod: "lowestElement", checkOrigin: false}, '#smashLeads')
